import { render } from "./MouseTrailEffect.vue?vue&type=template&id=33a6814d&scoped=true"
import script from "./MouseTrailEffect.vue?vue&type=script&lang=js"
export * from "./MouseTrailEffect.vue?vue&type=script&lang=js"

import "./MouseTrailEffect.vue?vue&type=style&index=0&id=33a6814d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a6814d"]])

export default __exports__